import '../../base/style/index.mjs';
import 'element-plus/theme-chalk/src/loading.scss';
//# sourceMappingURL=index.mjs.map
